import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useReduxSrAlert = (selector, messageFn, onMessageSet) => {
  const [alertMessage, setAlertMessage] = useState('');
  const dispatch = useDispatch();
  const alertState = useSelector(selector);

  useEffect(() => {
    if (alertState) {
      const message = messageFn(alertState);
      setAlertMessage(message);
      onMessageSet && dispatch(onMessageSet());
    }

    const timeoutId = setTimeout(() => {
      setAlertMessage('');
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertState]);

  return alertMessage;
};
